import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommLeafIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M3.74122 2.95192C3.96627 3.00359 4.11403 3.13459 4.1905 3.21559C5.76189 4.87942 7.37863 5.33577 9.13973 5.65553C9.38611 5.70026 9.63827 5.74237 9.8952 5.78527C11.4592 6.04641 13.2 6.33709 14.8921 7.43019C18.3353 9.65396 19.6045 13.2407 18.5499 16.2679C19.1577 16.4148 19.7846 16.5379 20.4336 16.6378C20.843 16.7008 21.1238 17.0837 21.0609 17.4931C20.9979 17.9025 20.6149 18.1833 20.2055 18.1203C19.3997 17.9964 18.6252 17.8384 17.8775 17.6462C16.8555 19.1927 15.0214 19.9893 13.1033 20.0634C11.0872 20.1412 8.87601 19.4336 7.13903 17.8482L7.13878 17.848C4.7786 15.6919 3.54218 11.8743 2.97821 8.8425C2.69219 7.30487 2.56771 5.90703 2.5696 4.93C2.57052 4.4572 2.60049 4.02297 2.68231 3.7134C2.70402 3.63126 2.73481 3.5363 2.78097 3.44243C2.82298 3.357 2.90426 3.21712 3.05336 3.1029C3.2292 2.96819 3.4757 2.89095 3.74122 2.95192ZM17.1 15.8611C14.0494 14.8808 11.4665 13.2298 8.92938 10.8401C8.62785 10.5561 8.15319 10.5703 7.8692 10.8719C7.5852 11.1734 7.59941 11.648 7.90094 11.932C10.502 14.3819 13.1876 16.1244 16.3393 17.1897C15.6041 18.0114 14.4257 18.5112 13.0454 18.5645C11.4076 18.6277 9.58486 18.0496 8.15048 16.7405M17.1 15.8611C17.9462 13.5453 17.0666 10.6202 14.0783 8.69021L14.0782 8.69017C12.6657 7.77774 11.2551 7.53866 9.68868 7.2732C9.42118 7.22786 9.14913 7.18176 8.87176 7.1314C7.30526 6.84698 5.66656 6.42779 4.07135 5.14569C4.08663 6.00597 4.20187 7.21859 4.45292 8.56819C5.00598 11.5414 6.1728 14.9337 8.15024 16.7403"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
